var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.25 0C3.70012 0 0 3.70012 0 8.25C0 13.9686 7.447 21.4816 7.76325 21.7993C7.898 21.9326 8.074 22 8.25 22C8.426 22 8.602 21.9326 8.73675 21.7993C9.053 21.4816 16.5 13.9686 16.5 8.25C16.5 3.70012 12.7999 0 8.25 0ZM8.25 20.3184C6.60825 18.5611 1.375 12.6184 1.375 8.25C1.375 4.45913 4.45913 1.375 8.25 1.375C12.0409 1.375 15.125 4.45913 15.125 8.25C15.125 12.6143 9.89175 18.5611 8.25 20.3184Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.25 4.125C5.97575 4.125 4.125 5.97575 4.125 8.25C4.125 10.5243 5.97575 12.375 8.25 12.375C10.5243 12.375 12.375 10.5243 12.375 8.25C12.375 5.97575 10.5243 4.125 8.25 4.125ZM8.25 11C6.73337 11 5.5 9.76663 5.5 8.25C5.5 6.73337 6.73337 5.5 8.25 5.5C9.76663 5.5 11 6.73337 11 8.25C11 9.76663 9.76663 11 8.25 11Z",
    fill: "#333333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.ad21aba51ea7fbc102853392f2162428.svg";
export { ForwardRef as ReactComponent };